module.exports = __webpack_public_path__ + "img/child-psychologist.d4164eb6.png";